import React, { useState } from 'react';
import classnames from 'classnames';
import { ShareViaEmailModal, NeuroMessage, PrintButton } from '@ignitesales/neuro-application';
import ReactSVG from 'react-svg';

const SocialActions = ({ className }) => {
  const classes = classnames(className, 'social-actions');
  const [ showEmailModal, setEmailModalView ] = useState(false);

  return <div className={ classes }>
    <a className="social-actions__action email" onClick={ () => setEmailModalView(true) } onKeyPress={() => setEmailModalView(true)} tabIndex="0">
      <ReactSVG src="/classpath/assets/images/regions-icons/email.svg"/>
      <NeuroMessage id="socialActions.email" tagName='span' />
    </a>
    <PrintButton tagName='a' className="social-actions__action print" shouldOpenDetailsPage={true} tabIndex="0">
      <ReactSVG src="/classpath/assets/images/regions-icons/printer.svg"/>
      <NeuroMessage id="socialActions.print" tagName='span' />
    </PrintButton>
    <ShareViaEmailModal isOpen={ showEmailModal } onClose={ () => setEmailModalView(false) } className='shareViaEmail'/>
  </div>;
};

export default SocialActions;
